"use strict";
import "lodash";
import moment from "moment";
import { svc_addOne, svc_editOne, svc_fetchOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import config from "@/../config/config.json";

// need to change the endpointBasePrefix
const endpointBasePrefix = "xero/config";

const Model = {
	namespace: "m_XeroInvoiceConfig",
	state: {
		config: {},
		configs: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { configs } }) {
			return { ...state, configs };
		},
		handleFetchOne(state, { payload: { result } }) {
			return { ...state, config: result };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let configs = yield call(svc_search, `${endpointBasePrefix}`, payload);

			_.forEach(configs.result, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["enabled_from"], config.dateFormat);

				if (row.is_enabled)
					row.hideEnableBtn = true;
				if (!row.is_enabled)
					row.hideDisableBtn = true;
			});

			yield put({
				type: "handleFetchAll",
				payload: { configs },
			});

			return configs;
		},

		*addOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			// convert enabled date before sending
			payload.enabled_from = moment(payload.enabled_from, config.dateFormat).format("YYYY-MM-DD");

			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},

		*editOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			// convert enabled date before sending
			payload.enabled_from = moment(payload.enabled_from, config.dateFormat).format("YYYY-MM-DD");
			
			const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
